export default {
      id: "snapshot-blue-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#snapshot-blue-usage",
      toString: function () {
        return this.url;
      }
    }